import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PageHeader } from "@/components/PageStates";

export const Route = createFileRoute("/reset-password")({
  component: ResetPassword,
});

function ResetPassword() {
  const navigate = useNavigate();
  const [p1, setP1] = useState("");
  const [p2, setP2] = useState("");

  return (
    <div className="app-viewport bg-bg">
      <PageHeader title="设置新密码" onBack={() => history.back()} />
      <form
        onSubmit={(e) => {
          e.preventDefault();
          if (p1 !== p2) {
            toast.error("两次输入不一致");
            return;
          }
          toast.success("密码已更新");
          navigate({ to: "/" });
        }}
        className="space-y-4 px-6 pt-6"
      >
        <div className="space-y-1.5">
          <Label htmlFor="p1">新密码</Label>
          <Input
            id="p1"
            type="password"
            value={p1}
            onChange={(e) => setP1(e.target.value)}
            required
            minLength={6}
          />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="p2">确认新密码</Label>
          <Input
            id="p2"
            type="password"
            value={p2}
            onChange={(e) => setP2(e.target.value)}
            required
            minLength={6}
          />
        </div>
        <Button type="submit" className="h-12 w-full">
          保存新密码
        </Button>
      </form>
    </div>
  );
}
